import { hiddenPanels, panels } from '../panels';

const normalise = (pathname) =>
    pathname && pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

const toRegex = (pattern) => new RegExp(`^${pattern.replace(/\/:\w+\?/g, '(/[^/]+)?').replace(/:\w+/g, '[^/]+')}$`);

/** Resolves a pathname to the human-readable page name shown in navigation affordances. */
class RouteLabelResolver {
    constructor(panelList, hiddenPanelList) {
        this.panels = panelList;
        this.hiddenPanels = hiddenPanelList;
    }

    labelFor(pathname) {
        const path = normalise(pathname);
        if (!path) return null;

        const panel = this.panels.find((p) => normalise(p.uri) === path);
        if (panel) return panel.name || null;

        // hiddenPanels is ordered most-specific-first, so the first match wins.
        const hidden = this.hiddenPanels.find((p) => toRegex(p.uri).test(path));
        return hidden?.name || null;
    }
}

export const routeLabels = new RouteLabelResolver(panels, hiddenPanels);

export default RouteLabelResolver;
